import { ShieldCheck } from 'lucide-react';
import type { ReactNode } from 'react';

import { EnvBadge } from './EnvBadge';

export const AppHeader = ({ right }: { right?: ReactNode }) => (
  <header className="sticky top-0 z-30 flex h-14 shrink-0 items-center justify-between gap-4 border-b bg-white px-4 sm:px-6">
    <div className="flex min-w-0 items-center gap-3">
      <img src="/favicon.svg" alt="" className="h-7 w-7" />
      <span className="font-bold tracking-tight">
        <span className="text-brand-violet">LOGISTECH</span>
        <span className="text-brand-teal">-LGT</span>
      </span>
      <span className="hidden items-center gap-1.5 border-l pl-3 text-sm font-medium text-muted-foreground sm:flex">
        <ShieldCheck className="h-4 w-4 text-brand-violet" aria-hidden />
        Admin plateforme
      </span>
      <EnvBadge />
    </div>
    {right}
  </header>
);
